import { render, staticRenderFns } from "./mentorRoles.vue?vue&type=template&id=688f973d&scoped=true"
import script from "./mentorRoles.vue?vue&type=script&lang=js"
export * from "./mentorRoles.vue?vue&type=script&lang=js"
import style0 from "./mentorRoles.vue?vue&type=style&index=0&id=688f973d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688f973d",
  null
  
)

export default component.exports